import { memo } from 'react';

import Text from '@ui/text/text/text';

const RenderNoOptionsContent = memo(() => {
  return (
    <div className="padding-16">
      <Text className="S2" design="GlobalIcoText3">
        No members found
      </Text>
    </div>
  );
});

RenderNoOptionsContent.displayName = 'RenderNoOptionsContent';

export default RenderNoOptionsContent;
